import { createSelector } from "reselect";
import moment from 'moment';

const unavailabilities = state => state.unavailabilities;

const getData = (data) => {
  const unavailabilities = [...data];

  unavailabilities.forEach(item => {
    item.displayStart = moment(item.start).format("DD/MM/YYYY HH:mm");
    item.displayEnd = moment(item.end).format("DD/MM/YYYY HH:mm");
  });

  return unavailabilities;
};

export default createSelector(
  unavailabilities,
  getData
);



// WEBPACK FOOTER //
// ./src/selectors/get_unavailabilities.js